<template>
  <div class="service_style_2_area text-center section_padding">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="service_img_info_box">
            <img src="/assets/images/shape/service-color-shape.png" class="service_info_color_shape" alt="shape">
          </div><!--end .service_img_info_box-->
          <p class="col-md-10 col-md-offset-1">As installers of sewer, water, and gas lines, much of our work involves bathroom plumbing.  We can help you make your dream bathroom a reality, clean clogged drains, make small and major repairs, and service your plumbing fixtures and equipment.</p>
        </div><!--end .col-md-12-->
      </div><!--end .row-->
    </div><!--end .container-->
  </div>
</template>

<script>
    export default {
      name: "ServicesThree"
    }
</script>

<style scoped>

</style>
